
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
export abstract class AbEventoPsim extends AppService {
  abstract getEventosByPessoaLogada(filter: AppFilter);
  abstract getTimelineByPessoaLogadaV2(filter: AppFilter);
  abstract getDetalhesEventosTimeline(idTimeline: number);
  abstract getEventosHubByPessoaLogada(filter: AppFilter);
  abstract isTimelineV2Ativo();
}
